import React, { useContext, useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import CompanyLogos from './CompanyLogos';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import { LanguageContext } from '../App';

export default function ClaimStatusHero({ companyLogo, companyName }) {
  const { language } = useContext(LanguageContext);
  const { currentUser, userCompany, userAdjusterName, isAdmin, logout } = useAuth();
  const es = language === 'es';
  const [profile, setProfile] = useState({ phone: '', jobTitle: '' });
  const [draft, setDraft] = useState(profile);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState('');
  useEffect(() => {
    let active = true;
    setLoading(true);
    getDoc(doc(db, 'users', currentUser.uid)).then(snapshot => {
      if (!active) return;
      const saved = snapshot.data()?.portalProfile || {};
      const next = { phone: saved.phone || '', jobTitle: saved.jobTitle || '' };
      setProfile(next);
      setDraft(next);
      setLoading(false);
    }).catch(() => { if (active) { setStatus('load-error'); setLoading(false); } });
    return () => { active = false; };
  }, [currentUser.uid]);
  const name = userAdjusterName || currentUser.displayName || (es ? 'Mi cuenta' : 'My account');
  const save = async event => {
    event.preventDefault();
    setSaving(true);
    setStatus('');
    const next = Object.fromEntries(Object.entries(draft).map(([key, value]) => [key, value.trim()]));
    try {
      await setDoc(doc(db, 'users', currentUser.uid), { portalProfile: next }, { merge: true });
      setProfile(next);
      setDraft(next);
      setStatus('saved');
    } catch { setStatus('save-error'); }
    finally { setSaving(false); }
  };
  return (
    <section className="cs-welcome" aria-labelledby="cs-title">
      <div className="cs-hero">
        <div className="cs-hero-copy">
          <h1 id="cs-title">{es ? 'Estado de reclamos' : 'Claim status'}<span>.</span></h1>
          <p>{es ? 'Cada reclamo, cada avance. Todo en un solo lugar.' : 'Every claim, every update. All in one place.'}</p>
          <div className="cs-company"><CompanyLogos company={companyName || userCompany} src={companyLogo} /><span>{companyName || (isAdmin ? (es ? 'Todas las empresas' : 'All companies') : userCompany)}</span></div>
        </div>
        <div className="cs-identity">
          <div className="cs-person"><span className="cs-avatar" aria-hidden="true">{name.split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase()}</span><div><strong>{name}</strong><span>{profile.jobTitle || (es ? 'Tu espacio de trabajo' : 'Your workspace')}</span></div></div>
          <p className="cs-email">{currentUser.email}</p>
          <div className="cs-identity-actions"><button type="button" className="cs-profile-button" aria-expanded={open} aria-controls="cs-profile" onClick={() => { setOpen(!open); setDraft(profile); setStatus(status === 'load-error' ? status : ''); }}><i className="fa-solid fa-user-pen" aria-hidden="true" />{es ? 'Mi perfil' : 'My profile'}<i className={`fa-solid fa-chevron-${open ? 'up' : 'down'}`} aria-hidden="true" /></button><button type="button" className="cs-logout" onClick={logout}>{es ? 'Salir' : 'Log out'}<i className="fa-solid fa-arrow-right-from-bracket" aria-hidden="true" /></button></div>
        </div>
      </div>
      {open && <form id="cs-profile" className="cs-profile" onSubmit={save}>
        <div className="cs-profile-heading"><h2>{es ? 'Hazlo tuyo' : 'Make it yours'}</h2><p>{es ? 'Actualiza tus datos personales del portal. Tu nombre en los reclamos, empresa y correo de acceso se administran con CSR.' : 'Update your personal portal details. Your claim name, company and sign-in email are managed with CSR.'}</p></div>
        <fieldset disabled={loading || saving || status === 'load-error'}>
          <legend className="cs-sr-only">{es ? 'Datos personales' : 'Personal details'}</legend>
          {[['phone', es ? 'Teléfono' : 'Phone', 'tel', 'tel'], ['jobTitle', es ? 'Cargo' : 'Job title', 'text', 'organization-title']].map(([key, label, type, autoComplete]) => <label key={key} htmlFor={`cs-${key}`}>{label}<input id={`cs-${key}`} type={type} autoComplete={autoComplete} maxLength={key === 'phone' ? 40 : 100} value={draft[key]} onChange={event => setDraft({ ...draft, [key]: event.target.value })} /></label>)}
          <div className="cs-save-actions"><button className="cs-save" type="submit">{saving ? (es ? 'Guardando…' : 'Saving…') : (es ? 'Guardar cambios' : 'Save changes')}</button><button type="button" onClick={() => { setOpen(false); setDraft(profile); }}>{es ? 'Cancelar' : 'Cancel'}</button></div>
        </fieldset>
        <p role="status" className="cs-feedback">{loading ? (es ? 'Cargando perfil…' : 'Loading profile…') : status === 'saved' ? (es ? 'Tus cambios se guardaron.' : 'Your changes have been saved.') : status === 'load-error' ? (es ? 'No se pudo cargar el perfil. Recarga la página para volver a intentarlo.' : 'Could not load your profile. Reload the page to try again.') : status === 'save-error' ? (es ? 'No se pudo guardar. Tus cambios siguen aquí; vuelve a intentarlo.' : 'Could not save. Your changes are still here; try again.') : ''}</p>
      </form>}
    </section>
  );
}
